import { useParams, useSearchParams } from "react-router-dom";
import {
  CarAssetClassDftItem,
  useAssetClassSummaryStat,
} from "../useAssetClassSummaryStat";
import { AssetClassLoadType } from "@app/features/assets/useAssetClasses";
import { PdfDftSingleReport } from "./PdfDftSingleReport";
import { assetClassAnalysisPages } from "@app/const/route.const";
import { PdfDftCompareReport } from "./PdfDftCompareReport";

export const DFT_CHART_HEIGHT = 192;

export const PdfDistanceFromTrendReportPage = () => {
  const [searchParams] = useSearchParams();

  const params =
    assetClassAnalysisPages.getPdfDistanceFromTrendReportParams(searchParams);

  const assetClassAnalysis = useAssetClassSummaryStat({
    type: AssetClassLoadType.byLatestSimulationJob,
    filterByUsableInPortfolios: true,
  });

  let item1: CarAssetClassDftItem | undefined;
  let item2: CarAssetClassDftItem | undefined;

  if (params.isCompare) {
    const items = assetClassAnalysis.getDftItemsForCompare(
      params.assetClass1Id,
      params.assetClass2Id,
    );
    item1 = items.item1;
    item2 = items.item2;
  } else {
    item1 = assetClassAnalysis.dftItems.find(
      (i) => i.level4Id === params.assetClass1Id,
    );
    item2 = undefined;
  }

  return params.isCompare ? (
    <PdfDftCompareReport
      isLoading={assetClassAnalysis.isLoading}
      dftItem1={item1}
      dftItem2={item2}
    />
  ) : (
    <PdfDftSingleReport
      isLoading={assetClassAnalysis.isLoading}
      dftItem={item1}
    />
  );
};
